import { I621Form } from 'legacy/lut/features/partner360/configuration'
import { IShareOfBusiness } from 'legacy/lut/features/partner360/shareOfBusiness/models'

export const map621ToShareOfBusiness = (data: I621Form): IShareOfBusiness => {
  return {
    a3: {
      hpBrand: data.A3HP || 0,
      allBrands: data.A3AllBrands || 0,

      topVendorBrand1: {
        name: data.A3TopVendorBrand1 || '',
        spend: data.A3TopVendorBrand1Spend || 0,
      },

      topVendorBrand2: {
        name: data.A3TopVendorBrand2 || '',
        spend: data.A3TopVendorBrand2Spend || 0,
      },

      topVendorBrand3: {
        name: data.A3TopVendorBrand3 || '',
        spend: data.A3TopVendorBrand3Spend || 0,
      },

      otherBrandSpend: data.A3TopVendorBrandOtherSpend || 0,
      previousUnits: data.PrevUnitsA3 || 0,
    },

    a4: {
      hpBrand: data.A4HP || 0,
      allBrands: data.A4AllBrands || 0,

      topVendorBrand1: {
        name: data.A4TopVendorBrand1 || '',
        spend: data.A4TopVendorBrand1Spend || 0,
      },

      topVendorBrand2: {
        name: data.A4TopVendorBrand2 || '',
        spend: data.A4TopVendorBrand2Spend || 0,
      },

      topVendorBrand3: {
        name: data.A4TopVendorBrand3 || '',
        spend: data.A4TopVendorBrand3Spend || 0,
      },

      otherBrandSpend: data.A4TopVendorBrandOtherSpend || 0,
      previousUnits: data.PrevUnitsA4 || 0,
    },

    calculateHPBrandsOverLastYears:
      typeof data.HPBrandsOverLastYears === 'number' ? data.HPBrandsOverLastYears : null,

    monthlyInvoicedPagesAllBrands: data.MonthlyInvoicedPagesAllBrands || 0,
    monthlyInvoicedPagesHP: data.MonthlyInvoicedPagesHP || 0,

    averageVolumePerDeviceHP: data.AverageVolumePerDeviceHP || 0,
    averageVolumePerDeviceAllBrands: data.AverageVolumePerDeviceAllBrands || 0,

    contractualCustomerCountHP: data.ContractualCustomerCountHP || 0,
    contractualCustomerCountAllBrands: data.ContractualCustomerCountAllBrands || 0,

    lastFinancialYearRevenuesHP: data.LastFYRevenuesHP || 0,
    lastFinancialYearRevenuesAllBrands: data.LastFYRevenuesAllBrands || 0,

    phyContractualUnitsA3: data.PHYContractualUnitsA3 || 0,
    phyContractualUnitsA4: data.PHYContractualUnitsA4 || 0,
    phyContractualUnitsTotal: data.PHYContractualUnitsTotal || 0,
    p5yContractualUnitsA3: data.P5YContractualUnitsA3 || 0,
    p5yContractualUnitsA4: data.P5YContractualUnitsA4 || 0,
    p5yContractualUnitsTotal: data.P5YContractualUnitsTotal || 0,
    mifUpdateRequired: data.MIFUpdateRequired || 0,
  }
}
